module.exports = __webpack_public_path__ + "img/360.e6ec1952.jpg";